import React from 'react'
import MenuRadioAnswers from './MenuRadioAnswers'
import MenuQuestion from './MenuQuestion'
import MenuCheckboxAnswers from './MenuCheckboxAnswers'
import { Field } from 'redux-form'
import { valueRequired, minSelect, maxSelect } from '../../util/validators'
import cn from 'classnames'
import PersonalizeButtons from './PersonalizeButtons'
import { InputError } from '@foodsby/nutrient'
import { Textarea } from '../common/reduxForms/Textarea'
import { LOCAL_STORAGE_ERROR } from '../../util/webStorageUtils'

export const formName = 'personalize'
export const questionPrefix = 'q_'

const PersonalizeOrderForm = ({
  displayedQuestions,
  orderSubtotal, // The total of the menu item currently being edited, including any new modifications
  orderCartTotal, // The post personalized price of the current pre-checkout cart
  checkoutCartTotal, // The post personalized price of the current in-checkout cart
  editedOrderItemPrice, // The total of the menu item currently being edited, not including any new modifications
  questions,
  answers,
  handleSubmit,
  pristine,
  reset,
  submitting,
  input,
  invalid,
  onCheckboxChange,
  onRadioChange,
  menuItemForEdit,
  onSubmit,
  personalizeFormError,
  isCartSaving,
  isEditingOrder,
  isEditingFromMenu,
  isEditingFromCheckout,
  isEditingPastOrder,
  orderCartLength,
  checkoutCartLength,
  isAuthenticated,
  requiredQuestionsAnswers,
}) => {
  const buttonClass = cn({
    disabled: invalid,
    'add-item-and-checkout': !invalid,
    checkoutButton: true,
  })
  const buttonLink = cn({
    'disabled link': invalid,
    link: !invalid,
  })
  const editFromMenuClasses = cn({
    'col-xs-offset-5 col-xs-7': !isAuthenticated,
    'checkout-button-item': true,
  })
  return (
    <form>
      {displayedQuestions.map(function(question) {
        const firstLevelAnswers = question.answers.map(a => answers[a])
        let isRadio =
          question.minimumSelection === 1 && question.maximumSelection === 1
        return (
          <MenuQuestion
            className="menu-question"
            isEditingOrder={isEditingOrder}
            isRadio={isRadio}
            key={question.id}
            menuItemForEdit={menuItemForEdit}
            question={question}
            valid={!requiredQuestionsAnswers[`${questionPrefix}${question.id}`]}
          >
            {isRadio ? (
              <Field
                answers={firstLevelAnswers}
                component={MenuRadioAnswers}
                name={`${questionPrefix}${question.id}`}
                normalize={value => Number(value)}
                onAnswerChange={onRadioChange}
                question={question}
                questionId={question.id}
                validate={valueRequired}
              />
            ) : (
              <Field
                answers={firstLevelAnswers}
                component={MenuCheckboxAnswers}
                name={`${questionPrefix}${question.id}`}
                onAnswerChange={onCheckboxChange}
                validate={[
                  maxSelect(question.maximumSelection),
                  minSelect(question.minimumSelection),
                ]}
              />
            )}
          </MenuQuestion>
        )
      })}
      <section className="segment">
        <h2 className="segment-title">Special Instructions</h2>
        <Field
          component={Textarea}
          id="specialInstructions"
          maxLength="500"
          name="specialInstructions"
        />
      </section>
      {isEditingFromMenu ? (
        <PersonalizeButtons
          buttonOnClick={handleSubmit(values => onSubmit(values, true))}
          buttonText="Update and Checkout"
          cartLength={orderCartLength}
          disableButton={submitting || isCartSaving}
          disableLink={submitting || isCartSaving}
          editing
          editingClass={editFromMenuClasses}
          itemSubtotal={orderSubtotal}
          linkClassName={buttonLink}
          linkOnClick={handleSubmit(values => onSubmit(values, false))}
          linkText="Update and Add More Items"
          orderSubtotal={
            Number(orderSubtotal) + orderCartTotal - editedOrderItemPrice
          }
          visible={isAuthenticated}
        />
      ) : isEditingFromCheckout ? (
        <PersonalizeButtons
          buttonOnClick={handleSubmit(values => onSubmit(values, true))}
          buttonText="Update Order"
          cartLength={checkoutCartLength}
          disableButton={submitting || isCartSaving}
          editing
          editingClass="col-xs-offset-6 col-xs-6"
          itemSubtotal={orderSubtotal}
          orderSubtotal={
            Number(orderSubtotal) + checkoutCartTotal - editedOrderItemPrice
          }
        />
      ) : (
        //  Not yet added to cart
        <PersonalizeButtons
          buttonClassName={buttonClass}
          buttonOnClick={handleSubmit(values => onSubmit(values, true))}
          buttonText="Checkout"
          cartLength={orderCartLength}
          disableButton={submitting || isCartSaving}
          disableLink={submitting || isCartSaving}
          itemSubtotal={orderSubtotal}
          linkClassName={buttonLink}
          linkOnClick={handleSubmit(values => onSubmit(values, false))}
          linkText="Add More Items"
          orderSubtotal={Number(orderSubtotal) + Number(orderCartTotal)}
          visible="true"
        />
      )}
      <div className="row middle-xs">
        <div className="col-xs-12 center-xs">
          {personalizeFormError && (
            <InputError>
              {personalizeFormError.message.includes('QuotaExceeded')
                ? LOCAL_STORAGE_ERROR
                : personalizeFormError.message}
            </InputError>
          )}
        </div>
      </div>
    </form>
  )
}

export default PersonalizeOrderForm
